export default __webpack_public_path__ + "static/media/brandpool.ddf3e2f6.jpg";